import React, { useEffect, useState } from 'react';
import { Form, Input, Popconfirm, Table, Typography, DatePicker, Button, Checkbox, Tag, InputNumber } from 'antd';
import { CloseOutlined, DeleteOutlined, EditFilled, SaveFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import InputModal from '../../../../../Components/InputModal';
import { GetAllParameterMain } from '../../../../../API/GetData';
import { formatRupiah } from '../../../../../Components/Global';

const { TextArea } = Input;
const { Title } = Typography;
const dateFormat = 'YYYY-MM-DD';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    onData,
    onDataParams,
    onEdit,
    ...restProps
}) => {

    useEffect(() => {
        if (onEdit) {
            setOpenParameter(true);
        }
    }, [onEdit])

    const [valueSubcont, setValueSubcont] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [dataParameter, setDataParameter] = useState([]);
    const [selectParameter, setSelectParameter] = useState("");
    const [openParameter, setOpenParameter] = useState(false);

    useEffect(() => {
        const fetchParameter = async () => {
            try {
                setIsLoading(true);

                const response = await GetAllParameterMain();
                setDataParameter(response);

                if (onEdit) {
                    const [selectParams] = response.filter(item => item.ParameterCode === record.ParameterCode);
                    setSelectParameter(selectParams);
                    // console.log('onEdit', selectParams);

                }
            } catch (error) {
                console.log(error);
            } finally {
                setOpenParameter(false);
                setIsLoading(false);
            }
        }
        if (openParameter) {
            fetchParameter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openParameter]);

    useEffect(() => {
        if (selectParameter) {
            onDataParams(selectParameter);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectParameter]);


    return (
        <td {...restProps}>
            {editing ? (
                <div>

                    {dataIndex === 'Description' ? (
                        <Form.Item
                            name={dataIndex}
                            style={{
                                margin: 0,
                            }}
                        >
                            <TextArea rows={4} placeholder={title} />
                        </Form.Item>

                    ) : dataIndex === 'ParameterName' && editing ? (
                        <InputModal
                            title="PARAMETER"
                            label={title}
                            name="ParameterName"
                            dataSource={dataParameter}
                            loading={isLoading}
                            columns={columnsParameter}
                            onData={(values) => setSelectParameter(values)}
                            onOpenModal={(values) => setOpenParameter(values)}
                            onFormDetail={true}
                        />
                    ) : dataIndex === 'SubcontStatus' && editing ? (
                        <Form.Item
                            name={dataIndex}
                            valuePropName="checked"
                            style={{
                                margin: 0,
                            }}
                        >
                            <Checkbox onChange={(value) => setValueSubcont(value.target.checked)}></Checkbox>
                        </Form.Item>
                    ) : dataIndex === 'Labsubcont' && editing ? (
                        <Form.Item
                            name={dataIndex}
                            style={{ margin: 0 }}
                            rules={valueSubcont ? [
                                {
                                    required: true,
                                    message: `Please Input ${title}!`,
                                },
                            ] : []} // Jika valueSubcont falsy, set rules sebagai array kosong
                        >
                            <Input placeholder={title} />
                        </Form.Item>

                    ) : (

                        <Form.Item
                            name={dataIndex}
                            style={{
                                margin: 0,
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: `Please Input ${title}!`,
                                },
                            ]}
                        >
                            {dataIndex === 'DueDate' && editing ? (

                                <DatePicker
                                    format={dateFormat}
                                    placeholder={title}
                                />

                            ) : dataIndex === 'Amount' && editing ? (
                                <InputNumber
                                    placeholder={title}
                                    formatter={(value) =>
                                        `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                                    }
                                    parser={(value) =>
                                        value?.replace(/Rp\s?|(\.*)/g, '')
                                    }
                                    className="w-full"
                                />
                            ) : (

                                <Input placeholder={title} />

                            )}
                        </Form.Item>
                    )}

                </div>
            ) : (
                children
            )
            }
        </td >
    );
};


const FormParameter = ({ onSaveData, onEdit }) => {

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [editingKey, setEditingKey] = useState('');
    // const [loading, setLoading] = useState(false);
    // const [isDisable, setIsDisable] = useState(true);

    const [dataParameter, setDataParameter] = useState(null);

    useEffect(() => {
        if (form && dataParameter) {
            form.setFieldsValue({
                ParameterName: dataParameter.ParameterName
            })
        }
    }, [dataParameter, form]);

    useEffect(() => {
        if (onEdit.length > 0) {
            setData(
                onEdit.map((item, index) => ({
                    ...item,
                    key: index + 1,
                })).reverse());
            setCount(onEdit[onEdit.length - 1].key);
            onSaveData(onEdit);
        } else if (onEdit.length < 0) {
            setData([]);
            setCount(0);
            onSaveData([]);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onEdit]);


    const isEditing = (record) => record.key === editingKey;

    const handleEdit = (record) => {

        const DueDate = record.DueDate ? dayjs(record.DueDate) : '';
        const ParamsName = record.ParameterName ? record.ParameterName : '';

        form.setFieldsValue({
            ...record,
            DueDate: DueDate,
            ParameterName: ParamsName,
        });
        setEditingKey(record.key);
    };

    const handleDelete = (key) => {
        // setIsDisable(false);
        const deletedRow = data.find((row) => row.key === key);
        const deletedNumber = deletedRow.key;
        const deletedkey = deletedRow.key;

        const newData = data.filter((row) => row.key !== key);

        const updatedData = newData.map((row) => {

            if (row.key > deletedNumber && row.key > deletedkey) {
                return { ...row, key: row.key - 1 };
            }
            return row;
        });

        setCount(updatedData.length > 0 ? updatedData[0].key : 0);

        setData(updatedData);
        onSaveData(updatedData);

        // console.log("DataFormTran", updatedData);
    };


    const handleCancel = (record) => {
        if (!record.ParameterCode) {
            const newData = data.filter((item) => item.key !== record.key);
            setData(newData);
        } else {
            setEditingKey('');
        }
        setEditingKey('');

        // console.log("DataFormTran", data);
    };


    const handleSave = async (record) => {
        // setIsDisable(false);
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => record.key === item.key);
            const ParamsCode = dataParameter.ParameterCode;

            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                    ParameterCode: ParamsCode
                });
                setData(newData);
                setEditingKey('');
                console.log("DataFormTran", newData);
                onSaveData(newData);
            } else {
                newData.push({
                    ...row,
                    ParameterCode: ParamsCode
                });
                setData(newData);
                setEditingKey('');
                console.log("DataFormTran", newData);
                onSaveData(newData);
            }

            const editedRow = data.find((row) => row.key === record.key);
            const lastNumber = editedRow.key;
            // console.log(lastNumber);

            setCount(lastNumber);
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };



    const handleAdd = () => {

        const num = count + 1;
        // const code = (count + 1).toString().padStart(3, '0');

        // if (editingKey) {
        //     enqueueSnackbar("Complete the input form !", { variant: "warning" });
        //     return; // Stop saving if duplicate found
        // }

        const newData = {
            key: num,
            ParameterCode: "",
            ParameterName: "",
            Methode: "",
            SubcontStatus: false,
            Labsubcont: "",
            TAT: "",
            DueDate: "",
            Amount: "",
        };
        setData([newData, ...data]);
        handleEdit(newData);

        // console.log("DataFormTran", data);
    };

    // const handleSaveAllData = async () => {
    //     setLoading(true);
    //     setIsDisable(true);
    //     try {
    //         onSaveData(data);
    //         console.log("PostData", data);
    //         // enqueueSnackbar("Success add form table data!!", { variant: "success" });
    //     } catch (error) {
    //         console.log(error);
    //     }
    //     setLoading(false);
    // }

    // const handleCancelAllData = () => {
    //     setData([]);
    //     setCount(0);
    //     onSaveData([]);
    // }

    const columns = [
        {
            dataIndex: 'key',
            title: '#',
            sorter: (a, b) => a.key - b.key,
            fixed: 'left',
            width: 80,
        },
        // {
        //     dataIndex: 'ParameterCode',
        //     title: 'Parameter Code',
        //     key: 'ParameterCode',
        //     editable: true,
        // },
        {
            dataIndex: 'ParameterName',
            title: 'Parameter Name',
            key: 'ParameterName',
            editable: true,
        },
        {
            dataIndex: 'Methode',
            title: 'Methode',
            key: 'Methode',
            editable: true,
        },
        {
            dataIndex: 'SubcontStatus',
            title: 'Subcont Status',
            key: 'SubcontStatus',
            editable: true,
            align: "center",
            render: (value) => (
                <Tag color={value ? 'green' : 'red'}> {value ? 'Yes' : 'No'} </Tag>
            ),
        },
        {
            dataIndex: 'Labsubcont',
            title: 'Labsubcont',
            key: 'Labsubcont',
            editable: true,
        },
        {
            dataIndex: 'TAT',
            title: 'TAT',
            key: 'TAT',
            editable: true,
        },
        {
            dataIndex: 'DueDate',
            title: 'Due Date',
            key: 'DueDate',
            editable: true,
            render: (date) => dayjs(date).format('YYYY-MM-DD')
        },
        {
            dataIndex: 'Amount',
            title: 'Amount',
            key: 'Amount',
            editable: true,
            render: (value) => <p>Rp {formatRupiah(value)}</p>
        },
        {
            dataIndex: 'Action',
            title: 'Action',
            width: 100,
            fixed: 'right',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                        <Typography.Link onClick={() => handleSave(record)}>
                            <Button icon={<SaveFilled />} type="text" />
                        </Typography.Link>

                        <Typography.Link onClick={() => handleCancel(record)}>
                            <Button icon={<CloseOutlined />} type="text" />
                        </Typography.Link>
                    </span>
                ) : (
                    <span style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                        <Typography.Link onClick={() => handleEdit(record)}>
                            <Button icon={<EditFilled />} type="text" />
                        </Typography.Link>
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                            <Link>
                                <Button icon={<DeleteOutlined />} type="text" />
                            </Link>
                        </Popconfirm>
                    </span>
                );
            },
        }
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
                onData: data,
                onDataParams: (values) => setDataParameter(values),
                onEdit: onEdit
            }),
            ...col,
        };
    });

    return (

        <div className="border rounded-md p-4 mb-4">
            <Form form={form} component={false}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        margin: "0 10px 10px"
                    }}
                >
                    <Title level={3} style={{ margin: "0" }}>
                        Parameter
                    </Title>
                    <div className="flex gap-2">
                        <Button
                            onClick={handleAdd}
                            type="primary"
                        // disabled={!!editingKey || !FacilityCode || !WONumber}
                        >
                            + Add Data
                        </Button>
                    </div>
                </div>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    scroll={{ x: 'max-content' }}
                />
                {/* {!onApproval && (
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "flex-end",
                        margin: "10px 10px 0"
                    }}
                >
                    <Popconfirm title="Sure to clear all data?" onConfirm={handleCancelAllData}
                    >
                        <Button
                            disabled={!!editingKey || !!isDisable}
                        >
                            <span>Cancel</span>
                        </Button>
                    </Popconfirm>
                    <Button
                        type="primary"
                        onClick={handleSaveAllData}
                        loading={loading}
                        disabled={!!editingKey || !!isDisable}
                    >
                        <span>Save</span>
                    </Button>

                </div>
            )} */}
            </Form>
        </div>
    );
};
export default FormParameter;


const columnsParameter = [
    {
        key: "ParameterCode",
        title: "Parameter Code",
        dataIndex: "ParameterCode",
    },
    {
        key: "ParameterName",
        title: "Parameter Name",
        dataIndex: "ParameterName",
    },
    {
        key: "ParameterNumber",
        title: "Parameter Number",
        dataIndex: "ParameterNumber",
    },
]